<script setup lang="ts">
import { toRefs } from 'vue'
import AnsweringRules from './answering-rules.vue'
import ChallengeNotes from './challenge-notes.vue'

const props = defineProps({
  activityQuestType: {
    type: Number,
    default: 1
  },
  isDelegationCode: {
    type: Boolean,
    default: false
  }
})
const {
  activityQuestType
} = toRefs(props)
</script>

<template>
  <div>
    <AnsweringRules v-if="activityQuestType === 1">
      <template #progress>
        <slot name="progress" v-on="$listeners" />
      </template>
      <template #exams>
        <slot name="exams" v-on="$listeners" />
      </template>
    </AnsweringRules>
    <template v-if="activityQuestType === 2">
      <ChallengeNotes>
        <template #progress>
          <slot name="progress" v-on="$listeners" />
        </template>
        <template v-if="!isDelegationCode" #exams>
          <slot name="exams" v-on="$listeners" />
        </template>
      </ChallengeNotes>
    </template>
  </div>
</template>
